export const MAX_DISPLAY_DAYS = 7

export const eventPreviewFields: string[] = [
  'id',
  'title',
  'event_id',
  'recurring_event_id',
  'calendar',
  'active',
  'event_date',
  'google_event_date',
  'recurrence_rules',
  'confirmed',
  'all_day',
  'receiver_numbers',
  'suggested_numbers',
  'suggestions_reviewed',
  'accepted_suggested_numbers',
  'created_at',
  'errors',
  'auto_activated_at',
  'auto_activation_undone_at',
  'auto_activation_revoked_at',
  'auto_activation_reason_code',
  'auto_activation_reason_params',
  'has_auto_activation_material',
  'can_undo_auto_activation',
]
